import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
// UI
import Checkbox from "rc-checkbox";

class CheckboxUI extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    // e.target.checked
    this.props.handleChange(e);
  }

  render() {
    /* CLASS */
    const checkboxClasses = classNames("input--group", this.props.className);
    const checkboxInputClasses = classNames(
      "checkbox checkbox",
      this.props.classNameCheckbox
    );

    return (
      <div className={checkboxClasses}>
        <label>
          <Checkbox
            name={this.props.name}
            // enum: 0, 1, 2
            // 0 - not checked
            // 1 - checked
            // 2 - ?
            defaultChecked={this.props.defaultChecked}
            onChange={this.onChange}
            // enum: 0, 1, 2
            // 0 - not checked
            // 1 - checked
            // 2 - ?
            checked={this.props.checked}
            disabled={this.props.disabled}
            prefixCls={checkboxInputClasses}
            // className={checkboxInputClasses}
          />
          &nbsp; {this.props.label}
        </label>
      </div>
    );
  }
}

CheckboxUI.defaultProps = {
  name: null,
  defaultChecked: false,
  handleChange: () => {
    return null;
  },
  checked: false,
  disabled: false,
  label: null,
  className: null,
  classNameCheckbox: null
};

CheckboxUI.propTypes = {
  name: PropTypes.string,
  defaultChecked: PropTypes.bool,
  handleChange: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
  classNameCheckbox: PropTypes.string
};

export default CheckboxUI;
